import { render, staticRenderFns } from "./TrafficChannel.vue?vue&type=template&id=87ff8130&"
import script from "./TrafficChannel.vue?vue&type=script&lang=js&"
export * from "./TrafficChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports